import { io } from "socket.io-client";

const {
    REACT_APP_API_BASE_URL,
    REACT_APP_SOCKET_PATH,

    REACT_APP_PARTNER_COOKIE,
    REACT_APP_USER_COOKIE
} = process.env

let credential = null

const token = window.sessionStorage.getItem(REACT_APP_PARTNER_COOKIE) || window.sessionStorage.getItem(REACT_APP_USER_COOKIE)
const tokenKey = window.sessionStorage.key(REACT_APP_PARTNER_COOKIE) || window.sessionStorage.key(REACT_APP_USER_COOKIE)

if (token) {
    credential = token
}

const SOCKET = io(REACT_APP_API_BASE_URL, {
    autoConnect: true,
    path: REACT_APP_SOCKET_PATH,
    auth: { 
        token: credential,
        sender: tokenKey
    }
})

SOCKET.on("connect_error", (err) => {
    console.log(`connect_error due to ${err.message}`);
})

export default SOCKET